import { latLng } from "leaflet";
export default [
    {
      id: 0,
      location: latLng(47.41322, -1.219482),
      name: "Plaza cleaning!", 
      picId: require('./assets/event-pictures/1.jpg'),
      creator: "Julio Vasco",
      participants: 3,
      time: '09:00 - 10/11/2022',
    },
    {
      id: 1,
      location: latLng(47.41422, -1.250482),
      name: "Recycling center help", 
      picId: require('./assets/event-pictures/2.jpg'),
      creator: "Paola Mendez",
      participants: 3,
      time: '12:00 - 04/03/2022',
    },
]